<template>
    <nav class="nav-list overflow-auto" style="display: block;" :class="`${collapse ? 'show' : ''} ${maxPage  ? 'icon-show' : ''}`">
        <div v-for="(item, key) in permissions.filter((e) => { return e.view == true})" :key="key">
            <router-link class="gv-link" :to="{ name: item.route }" v-if="item.route">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
            </router-link>
            <span class="gv-link" v-else-if="item.items.length == 0 && !item.route">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
            </span>
            <a v-else class="gv-link" data-toggle="collapse" :data-target="`#collapse_${item.id}`">
                <div class="down">
                    <i :class="`bi bi-${ item.items.findIndex((e) => { return $route.name == e.route}) != -1 ? 'caret-up' : 'caret-down' }`"></i>
                </div>
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
            </a>
            <div v-if="item.items.length > 0" class="collapse" :class="item.items.findIndex((e) => { return $route.name == e.route}) != -1 ? 'show' : ''" :id="`collapse_${item.id}`">
                <router-link class="gv-link pl-3" :class="`${$route.name == value.route ? 'active' : ''}`" :to="{ name: value.route }" v-for="(value, index) in item.items.filter((e) => { return e.view == true})" :key="index">
                    <i :class="value.icon"></i>
                    <span>{{ value.name }}</span>
                </router-link>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    props: {
        collapse: {
            type: Boolean,
            default: false
        },
        maxPage: {
            type: Boolean,
            default: false
        },
        permissions: {
            type: Array,
            default: () => { return [] }
        }
    }
}
</script>
<style>
.overflow-auto {
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;
  overflow-x: scroll;
}
.overflow-auto::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/layout/Navbar.vue